import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { Languages } from '~/constants/enums';
import { useBreakpoint } from '~/hooks';
import type useSwiperNavigation from '~/modules/valuation/hooks/useSwiperNavigation';

type SliderNavigationProps = Pick<
  ReturnType<typeof useSwiperNavigation>,
  'isEnd' | 'isInteracted' | 'isStart' | 'handleNext' | 'handlePrev'
>;

export default function SliderNavigation({
  isEnd,
  isInteracted,
  isStart,
  handleNext,
  handlePrev,
}: SliderNavigationProps) {
  const { i18n } = useTranslation('app');
  const { mobileScreen } = useBreakpoint();
  const isRtl = i18n.language === Languages.ARABIC;
  const arrowButtonBase =
    'h-[32px] w-[32px] rounded-full absolute flex items-center justify-center shadow-md border border-gray bg-white z-10';

  if (mobileScreen) return null;
  return (
    <>
      {!isEnd && (
        <button
          style={{ boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)' }}
          onClick={handleNext}
          className={`${arrowButtonBase}  ${
            isRtl ? 'left-0' : 'right-0'
          } top-1/2 -translate-y-1/2`}
        >
          <Icon
            name={isRtl ? 'chevron-large-left' : 'chevron-large-right'}
            size="16px"
          />
        </button>
      )}

      {!isStart && isInteracted && (
        <button
          onClick={handlePrev}
          style={{ boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)' }}
          className={`${arrowButtonBase} ${
            isRtl ? 'right-0' : 'left-0'
          } top-1/2 -translate-y-1/2`}
        >
          <Icon
            name={isRtl ? 'chevron-large-right' : 'chevron-large-left'}
            size="16px"
          />
        </button>
      )}
    </>
  );
}
